import objectAssign from 'object-assign';
import RestHelper from '../utils/RestHelper';

const INIT_HAUSANSCHLUSS_FORM = 'hausanschluss/INIT';
const SUBMIT_HAUSANSCHLUSS_FORM = 'hausanschluss/SUBMIT';
const SUBMIT_HAUSANSCHLUSS_FORM_SUCCESS = 'hausanschluss/SUBMIT_SUCCESS';
const SUBMIT_HAUSANSCHLUSS_FORM_ERROR = 'hausanschluss/SUBMIT_ERROR';

function savehausanschlussData(hausanschlussData, endpoint) {
  const params = {
    params: hausanschlussData
  };
  return RestHelper
    .post(endpoint, params);
}

export const loadDataInitiation = (dispatch, component) => {
  dispatch({
    type: INIT_HAUSANSCHLUSS_FORM,
    data: {
      component
    }
  });
};

export const dataRequest = (dispatch, state) => {
  dispatch({
    type: SUBMIT_HAUSANSCHLUSS_FORM,
    data: {
      values: state
    }
  });
};

export const dataRequestSuccess = (dispatch, response) => {
  dispatch({
    type: SUBMIT_HAUSANSCHLUSS_FORM_SUCCESS,
    data: {
      response: response.data
    }
  });
};

export const dataRequestError = (dispatch, error) => {
  dispatch({
    type: SUBMIT_HAUSANSCHLUSS_FORM_ERROR,
    data: {
      error
    }
  });
};

export const submitData = (dispatch, data, submitEndpoint) => {
  const resp = savehausanschlussData(data, submitEndpoint);
  dataRequest(dispatch, data, submitEndpoint);
  return resp
    .then((response) => {
      dataRequestSuccess(dispatch, response);
    }).catch((err) => {
      dataRequestError(dispatch, err);
      console.error(err); // eslint-disable-line no-console
    });
};

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case INIT_HAUSANSCHLUSS_FORM: {
      return objectAssign({}, state, action.data);
    }
    case SUBMIT_HAUSANSCHLUSS_FORM: {
      return objectAssign({}, state, action.data, { isRequestPending: true });
    }
    case SUBMIT_HAUSANSCHLUSS_FORM_SUCCESS: {
      return objectAssign({}, state, action.data, { isRequestPending: false, isSuccess: true });
    }
    case SUBMIT_HAUSANSCHLUSS_FORM_ERROR: {
      return objectAssign({}, state, action.data, { isRequestPending: false, isSuccess: false });
    }
    default:
      return state;
  }
}
